/* -------------------------------------------------------------------------- */
/*                            Schema Device Actions                           */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const deviceAction = new schema.Entity(
  'deviceActions',
  {},
  { idAttribute: (value) => `${value.deviceActionId}_${value.actionSource ?? 'WR'}` }
);
export const deviceActions = new schema.Array(deviceAction);
